import React from 'react';

import { styled } from '@mui/material/styles';
import { Card, Skeleton } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ColWrapper = styled('div')`
    flex: 0 0 auto;
    margin: 0 8px;
    overflow: hidden;
    width: 316px;
`;
const ProjectContainer = styled('div')`
    border-radius: 4px;
    height: calc(100% - 42px);
`;

const Title = styled('div')`
    display: block;
    margin-bottom: 16px;
`;

const PlaceholderList = ({ children, isEmpty, ready }) => {
    const { t } = useTranslation();

    if (ready) {
        if (isEmpty) {
            return <p>{t('There are no items to display')}</p>;
        }
        return children;
    }

    return [1, 2, 3, 4, 5, 6].map((key) => {
        return (
            <ColWrapper key={key}>
                <Title>
                    <Skeleton variant="rounded" />
                </Title>

                <ProjectContainer>
                    <Card sx={{ borderRadius: '4px' }}>
                        <Card.Body>
                            <Skeleton variant="rounded" />
                        </Card.Body>
                    </Card>
                </ProjectContainer>
            </ColWrapper>
        );
    });
};

PlaceholderList.propTypes = {
    children: PropTypes.node,
    isEmpty: PropTypes.bool,
    ready: PropTypes.bool,
};

export default PlaceholderList;
